import { useRef, useEffect, useState } from 'react';

/**
 * This component ensures SVG logos are rendered at their intrinsic size.
 *
 * Why this matters:
 * -----------------
 * When using <img> for SVGs, rendered size can differ from intrinsic size
 * even if no CSS explicitly scales them. This often happens due to layout
 * constraints or inherited styles from parent containers.
 */

const Logo = ({ src, alt }) => {
	const imgRef = useRef(null);
	const [size, setSize] = useState({ width: undefined, height: undefined });

	useEffect(() => {
		const img = imgRef.current;
		if (!img) return;

		const onLoad = () => {
			setSize({
				width: img.naturalWidth,
				height: img.naturalHeight,
			});
		};

		if (img.complete) {
			onLoad();
		} else {
			img.addEventListener('load', onLoad);
			return () => img.removeEventListener('load', onLoad);
		}
	}, [src]);

	return (
		<img ref={imgRef} src={src} alt={alt} width={size.width} height={size.height} style={{ display: 'block' }} />
	);
};

export default Logo;
